import React, { FC, useState } from "react"

import { DropdownButton } from "../buttons/DropdownButton"

interface IProps {
  value: number
  onValueChange: any
  columns: any[]
}

export const TableDropdown: FC<IProps> = (props) => {
  const { value, onValueChange, columns } = props
  const [open, setOpen] = useState<boolean>(false)

  const handleValueChange = (column: any): void => {
    onValueChange(column)
    setOpen(false)
  }

  return (
    <div className="relative">
      <DropdownButton value={value} handler={() => setOpen(!open)} />
      {open ? (
        <div className="mt-2 w-full absolute bg-[#F5F5F5] text-black border-gray-200 dark:bg-[#0C0C1A] dark:text-white dark:border-[rgba(255,255,255,0.1)] z-0">
          <ul className="rounded-md text-md text-black dark:text-white">
            {columns.map((column, key) => (
              <li
                key={key}
                onClick={() => handleValueChange(column)}
                className="px-4 py-2 transition-all hover:text-grey-light hover:dark:bg-[#16162b] cursor-pointer"
              >
                {column}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}
